import { translate } from '@/core/localization/translate';
import { Span } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { twMerge } from '@/domains/core/tamagoshiTailwind/util/twMerge';
const {
  message
} = translate({
  "message": "Unfortunately no products match your search."
});
interface Props {
  className?: string;
}
export function ProductNotFound({
  className
}: Props) {
  return <div className={twMerge('px-xs', className)}>
      <div className="mb-xs mt-s inline-flex h-[194px] w-full items-center
          justify-center rounded-container bg-foundation-primary px-m
          text-center">
        <Span scale="body2" weight="regular">
          {message}
        </Span>
      </div>
    </div>;
}
ProductNotFound.displayName = 'ProductNotFound';